/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/signInUser.config.json";
import axios from "axios";

export interface ISendOTPMethods extends IPluginMethodMap {
  sendOTP(args: {
    email: string;
    apiURL: string;
    sendOn: "sms" | "email" | "both";
  }): Promise<any>;
}

export class SendOTPService implements IAgentPlugin {
  readonly methods: ISendOTPMethods;
  constructor() {
    this.methods = {
      sendOTP: this.sendOTP.bind(this),
    };
  }

  async sendOTP(args: {
    email: string;
    apiURL: string;
    sendOn: "sms" | "email" | "both";
  }) {
    try {
      const res = await axios.post(`${args?.apiURL}${config?.sendOTPEP}`, {
        email: args?.email,
        sendOn: args?.sendOn,
      });
      if (res?.data) {
        console.log(`sendOTP`, res?.data);
        return res?.data;
      }
    } catch (err: any) {
      console.log(`sendOTP error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
